import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import BasicOrderInformation from '../../BasicOrderInformartion/BasicOrderInformation';
import CrmOrderDetails from '../../../../classes/CrmOrderDetails';

function WrongRoleOrderScreen({ order, loadError }) {
  const memoizedStatus = useMemo(() => order.shippingStatus,
    [order.shipmentList, order.shippingTimestamp]);
  return (
    <div>
      <p>
        Basic information about your order is listed below.
        Additional details and order tracking are restricted by your user role.
      </p>
      <div className="row">
        <div className="col-auto mb-2">
          <BasicOrderInformation
            orderNumber={order.orderNumber}
            orderStatus={memoizedStatus}
            billingStatus={order.paymentType}
            orderPlacedOn={order.createdAtDisplay}
            shippingMethod={order.shippingMethod}
            loadError={loadError}
          />
        </div>

        <div className="col-lg-6 col-sm-12">
          <div className="card bg-light" style={{ minHeight: '4rem' }}>
            <div className="card-body">
              <div className="pb-3">
                <ul className="list-unstyled">
                  <li>
                    <p>
                      You need an Administrator or Billing user role to access this record.
                      Please ask an administrator or provisioner on your
                      account to change your user role.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

WrongRoleOrderScreen.propTypes = {
  order: PropTypes.shape(CrmOrderDetails).isRequired,
  loadError: PropTypes.bool.isRequired,
};

export default WrongRoleOrderScreen;
